import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export class MessagePopover extends Component {
  renderPopover(popoverElement, popovertitle) {
    return (
      <Popover id="popoverMessage" title={ popovertitle }>
        { popoverElement }
      </Popover>
    );
  }

  render() {
    if (this.props.popoverComponent) {
      const popover = this.renderPopover(this.props.popoverComponent, this.props.popoverTitle);

      return (
        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={ popover } >
          { this.props.triggerComponent }
        </OverlayTrigger>
      );
    }
    return null;
  }
}

MessagePopover.propTypes = {
  triggerComponent: PropTypes.object,
  popoverComponent: PropTypes.object,
  popoverTitle: PropTypes.object,
};
